import React from "react";
import { SceneView } from "@react-navigation/core";

const ROUTE_TITLES = {
  login: "Login",
  dashboard: "Dashboard",
  bankacc: "Bank Accounts",
  BankAccNew: "New Bank Account",
  Customers: "Customers",
  CustomerNew: "New Customer",
  items: "Items",
  ItemsNew: "New Item",
  vendors: "Vendors",
  VendorsNew: "New Vendor",
  bills: "Bills",
  BillsNew: "New Bill",
  expenses: "Expenses",
  ExpensesNew: "New Expense",
  purchaseOrder: "Purchase Orders",
  PurchaseOrderNew: "New Purchase Order",
  paymentsMade: "Payments Made",
  PaymentsMadeNew: "New Payment",
  EstimatesNewButton: "New Estimate",
  SalesOrderNewButton: "New Sales Order",
  DeliveryChallansNew: "New Delivery Challan",
  InvoicesNew: "New Invoice",
  PaymentRecivedNew: "New Payment Received",
  CreditNoteNew: "New Credit Note",
  RecurringInvoiceNew: "New Recurring Invoice",
  Proforma: "Pro Forma Invoices",
  ProformaNew: "New Pro Forma Invoice",
  quotes: "Quotations",
  quotesnew: "New Quotation",
  EwayBills: "E-Way Bills",
  EwayBillsNew: "New E-Way Bill",
  GstFilling: "GST Filing",
  GstR1: "GSTR-1",
  GstR2: "GSTR-2",
  GstR3B: "GSTR-3B",
  CRMPage: "CRM",
  Users: "Users & Roles",
  SalesPerson: "Salespeople",
  ItemStocks: "Item Stock",
  SalesByInvoice: "Sales by Invoice",
  ApAgingSummary: "AP Aging Summary",
  BusinessPerfomanceRatios: "Business Performance Ratios",
  ProfitAndLossShedual3: "Profit and Loss Schedule III",
  buttonsUI: "Buttons",
};

const humanizeRouteName = (routeName = "") => {
  if (ROUTE_TITLES[routeName]) return ROUTE_TITLES[routeName];

  const cleanRouteName = routeName
    // Some legacy route keys describe the control that opens the page. That
    // implementation detail should never be shown in a browser title.
    .replace(/NewButton$/, "New")
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/[-_]+/g, " ")
    .replace(/\b\w/g, (letter) => letter.toUpperCase());

  // Keep create-page titles consistent: "New Invoice", not "Invoice New".
  if (cleanRouteName.endsWith(" New")) {
    return `New ${cleanRouteName.slice(0, -4)}`;
  }

  return cleanRouteName;
};

class SidebarView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  componentDidMount() {
    this.updateDocumentTitle();
  }

  componentDidUpdate() {
    this.updateDocumentTitle();
  }

  updateDocumentTitle = () => {
    const { navigation } = this.props;
    const activeRoute = navigation.state.routes[navigation.state.index];
    document.title = `Zarp | ${humanizeRouteName(activeRoute.routeName || activeRoute.key)}`;
  };

  render() {
    const { descriptors, navigation } = this.props;
    const activeKey = navigation.state.routes[navigation.state.index].key;
    const descriptor = descriptors[activeKey];
    return (
      <SceneView
        component={descriptor.getComponent()}
        navigation={navigation}
      />
    );
  }
}

export default SidebarView;
